import { useAuth } from "../lib/auth";
import EmptyModule from "./EmptyModule";

/**
 * ModuleGate — for module dashboard routes, renders a live empty-state when
 * the active organisation is a real/production tenant (is_demo === false).
 * Demo tenants (is_demo === true) render the full sample dashboards. Routes
 * without a `module` (Admin, Connectors, etc.) are never gated.
 */
export default function ModuleGate({ module, children }) {
  const { tenant } = useAuth();
  if (module && tenant && tenant.is_demo === false) {
    return <EmptyModule moduleKey={module} />;
  }
  return children;
}
